var Model = require("../types/Model.js");

module.exports = Model({
	name: "knoxunlock",
	// listeners: listeners,
});

function listeners() {
	return {
		"machinetracker:updated": handle_machinetracker_update,
	};
}
function handle_machinetracker_update() {

	// WHOOOPS!
	return;
}
